
var scope = {
  init: function () {
    
    scope.initTopHeaderSlider();
    scope.initProductTabsEventHandle();
    scope.featuredCollectionSliderInit();
    scope.footerPromotionsSliderInit();
    scope.triggerClickDrawerMenuFooterOnMobile();
    scope.showHeaderStickyIfScrollUp();
    scope.showSearchOnMobile();
    scope.closeSearchOnMobile();
    scope.clickIconCompare();
    scope.clickAddToCart();
    scope.showHelpChoosingPopup();
    scope.closeHelpChoosingPopup();
    scope.reStyleHoneycombUpsell();
    scope.drawerMenuSubLinkGo();
    scope.drawerMenuSubLinkBack();
    scope.closeSortpanel();
    scope.customerPanelToggle();
    if(jQuery("body").hasClass("template-product")) {
      scope.displayProductInfoSticky();
      scope.showPopupShippingPayment();
      scope.closePopupShippingPayment();
      scope.switchProductTabsV2();
      
      scope.productTabsV2SliderInit();
      scope.checkCurrentTabsActive();
      
      // scope.productFAQcountQuestions();
      // scope.productReviewsScrollDown();
      scope.sortContentOverviewTab();
      scope.readMoreOverviewTab();
      
      scope.checkContentArea10();
      scope.changeFrequentlyBoughtTogetherPosition();
      // scope.frequentlyBoughtUncheckedOnload();
      scope.frequentlyBoughtUncheckedEffect();
      scope.triggerClickTabDownload();

      //JS custom tab//
      scope.checkCurrentTabsVisible();
      scope.sortContentMobileTab();
      scope.readMoreContentTab();
    }
    // if(jQuery("body").hasClass("template-collection")) {
    //   scope.initSliderGridItems();
    // }
  },

  initTopHeaderSlider: function () {
    jQuery(".pre-header-inner").slick({
      dots: false,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 968,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  },

  initProductTabsEventHandle: function () {
    if (jQuery(".product-tabs").length > 0) {
      jQuery(".product-tabs").each(function () {
        var $tabs = jQuery(this);

        jQuery(".tabs-title a, .tabs-content .accordion-title", $tabs).on("click", function (e) {
          e.preventDefault();

          var $anchor = jQuery(this);
          var target = $anchor.attr("href");
          var targetID = target.replace("#", "");

          var $contentContainer = jQuery(target);
          var $titleLabel = jQuery("[aria-controls='" + targetID + "']");

          /* target is not exist or target already active */
          if ($contentContainer.length == 0) {
            return;
          } else if ($contentContainer.hasClass("active")) {
            if (window.innerWidth < 769) {
              jQuery(".tabs-content .tab-content.active", $tabs).removeClass("active");
              jQuery(".tabs-title .tab-title.active, .tabs-content .accordion-title.active", $tabs).removeClass("active");
            }

            return;
          }

          jQuery(".tabs-content .tab-content.active", $tabs).removeClass("active");
          $contentContainer.addClass("active");

          jQuery(".tabs-title .tab-title.active, .tabs-content .accordion-title.active", $tabs).removeClass("active");
          $titleLabel.addClass("active");

          setTimeout(function () {
            if (window.scrollY > $anchor.offset().top) {
              scope.scrollToAnchor($anchor);
            }

          }, 700);

          if (targetID == "product-reviews") {
            window.dispatchEvent(new Event("resize"));
          }

          return false;
        });

        jQuery(window).on("resize", function () {
          scope.initProductTabContentHeight(jQuery(".tabs-content .tab-content"));

          if (window.innerWidth >= 769 && jQuery(".tabs-content .tab-content.active", $tabs).length == 0) {
            jQuery("#product-details", $tabs).addClass("active");
            jQuery(".tabs-title .tab-title[aria-controls=product-details], .tabs-content .accordion-title[aria-controls=product-details]", $tabs).addClass("active");
          }
        });

        scope.initProductTabContentHeight(jQuery(".tabs-content .tab-content"));

        jQuery(".jdgm-preview-badge").on("click", function (e) {
          e.preventDefault();

          if (!jQuery("#product-reviews").hasClass("active")) {
            jQuery("#product-tabs a[aria-controls='product-reviews']").trigger("click");
          }

          return false;
        });



      });
    }
  },

  scrollToAnchor: function ($anchor) {
    jQuery("html, body").animate({ scrollTop: $anchor.offset().top - 100 }, 500);
  },
  scrollToAnchor_v2: function ($anchor, $offset) {
    jQuery("html, body").animate({ scrollTop: $anchor.offset().top - $offset }, 500);
  },
  initProductTabContentHeight: function ($el) {
    var stylesheet = "";
    var windowWidth = window.innerWidth;


    $el.each(function () {
      var height = jQuery(".tab-content--inner", this).outerHeight();
      var tabID = jQuery(this).attr("id")

      if (windowWidth < 769) {
        stylesheet += "#" + tabID + ".active{ height: " + height + "px; }"
      }

    });


    scope.inlineStylesheet("product-tabs-styles", stylesheet);
  },

  inlineStylesheet: function (id, stylesheet) {
    var linkElement = document.getElementById(id);
    var elementExist = true;

    if (!linkElement) {
      var linkElement = document.createElement("style");

      linkElement.id = id;

      elementExist = false;
    }

    linkElement.innerText = stylesheet;

    if (!elementExist) {
      var head = document.getElementsByTagName("head");
      head[0].append(linkElement);
    }
  },

  featuredCollectionSliderInit: function () {
    if (jQuery(".featured-collection--slider").length > 0) {
      let $slider = jQuery(".featured-collection--slider");
      let settings = $slider.data("slider-settings");

      settings = Object.assign(settings, { "autoplay": true, "autoplaySpeed": 5000, "draggable": true, "infinite": true, "speed": 500 });

      settings.responsive = [];

      if (settings.slidesToShow > 4) {
        settings.responsive.push({
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        });
      }

      if (settings.slidesToShow > 3) {
        settings.responsive.push({
          breakpoint: 981,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        });
      }

      if (settings.slidesToShow > 2) {
        settings.responsive.push({
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        });
      }

      $slider.slick(settings);
    }
  },
  displayProductInfoSticky: function() {
    
    let product_info_sticky = jQuery("#product-info--sticky");
    let element_target_mobile = jQuery(".product__quantity-payment");
    let element_target_desktop = jQuery(".product-single__meta--desktop");

    jQuery(window).scroll(function() {
      if(jQuery(window).width() > 768) {
        if(element_target_desktop.length >= 1) {
          if(jQuery(window).scrollTop() > element_target_desktop.offset().top + element_target_desktop.height()){
              product_info_sticky.addClass("showed");
              jQuery("body").addClass("product_info_show");
          }else{
              product_info_sticky.removeClass("showed");
              jQuery("body").removeClass("product_info_show");
          }
        }  
      }else{
        if(element_target_mobile.length >= 1) {
          if(jQuery(window).scrollTop() > element_target_mobile.offset().top){
              product_info_sticky.addClass("showed");
              jQuery("body").addClass("product_info_show");
          }else{
              product_info_sticky.removeClass("showed");
              jQuery("body").removeClass("product_info_show");
          }
        }  
      }
    });
    
  },
  showPopupShippingPayment: function() {
    let items = $('.shipping-delivery-payment a');
    items.on('click', function(e) {
      e.preventDefault();
      let url = $(this).attr('href');
      let full_url = 'https://' + document.domain + url + ".json";
      
      fetch(full_url)
      .then(res => res.json())
      .then(res => {
        let title = res['page']['title'];
        let body_html = res['page']['body_html'];
        
        let popup = $('.payment-shipping__popup');
        let overlay = $('.payment-shipping__overlay');
        let popup_title = $('.payment-shipping__popup .popup__title');
        let popup_content = $('.payment-shipping__popup .popup__content');
        popup_title.empty();
        popup_content.empty();
        popup_title.append(title);
        popup_content.append(body_html);
        popup.addClass('popup_show');
        overlay.addClass('overlay_active');
      });
    });
  },
  closePopupShippingPayment: function() {
    let popup_close = $('.payment-shipping__popup .popup__close');
    let popup = $('.payment-shipping__popup');
    let overlay = $('.payment-shipping__overlay');
    popup_close.on('click', function(e){
      e.preventDefault();
      popup.removeClass('popup_show');
      overlay.removeClass('overlay_active');
    });
  },
  switchProductTabsV2: function() {    
    let tabTitle = jQuery("#product-tabs-v2 .tab-title");
    let tabContent = jQuery("#product-tabs-v2 .tab-content");
    let outTabsTitle = jQuery("#product-tabs-v2 .product-tabs-title");
    let windowSize = jQuery(window).width();
    let heightHeader = jQuery("#shopify-section-header").height();
    tabTitle.click(function(e){
      e.preventDefault();
      let target = jQuery(this).attr('href');
      targetID = target.replace("#", "");
      
      if (targetID == "product-reviews") {
        window.dispatchEvent(new Event("resize"));
      }
      if (jQuery(this).hasClass("active")) {
        return;
      }else{
        tabTitle.removeClass("active");
        tabContent.removeClass("active");
        jQuery(this).addClass("active");
        let tab_name = jQuery(this).data("tab-name");
        tabContent.each(function(){
          if (jQuery(this).data("tab-name") == tab_name) {
            jQuery(this).addClass("active");
            let winTop = jQuery(window).scrollTop();
            var elTop = jQuery(this).offset().top;
              if(windowSize > 992){
                if(winTop<elTop){
                    jQuery('html, body').animate({
                        scrollTop: jQuery(this).offset().top - 60
                    }, 1000);
                } else {
                  jQuery('html, body').animate({
                      scrollTop: jQuery(this).offset().top - (60 + heightHeader)
                  }, 1000);
                }
              } else {
                if(winTop<elTop){
                  jQuery('html, body').animate({
                        scrollTop: jQuery(this).offset().top - 40
                  }, 1000);
                } else {
                  jQuery('html, body').animate({
                        scrollTop: jQuery(this).offset().top - (40 + heightHeader)
                  }, 1000);
                }
              }
              if(windowSize < 768){
                var totalWidth = jQuery("#product-tabs-v2.product-tabs-v3 .product-tabs-title .tabs-title").outerWidth()
                jQuery('#product-tabs-v2.product-tabs-v3 .product-tabs-title .tabs-title').css('width', totalWidth);
                var myScrollPos = jQuery('.tabs-title .tab-title.active').offset().left + jQuery('.tabs-title .tab-title.active').outerWidth(true) / 2 + jQuery('#product-tabs-v2.product-tabs-v3 .tabs-title').scrollLeft() - jQuery('#product-tabs-v2.product-tabs-v3 .tabs-title').width() / 2;
                jQuery('#product-tabs-v2.product-tabs-v3 .tabs-title').scrollLeft(myScrollPos);
              }
          }
        });
      }
    });
  },
  checkCurrentTabsVisible: function () {
      jQuery(window).scroll(function() {
          let winTop = jQuery(window).scrollTop();
          let winBottom = winTop + jQuery(window).height();
          let winMiddle = winTop + jQuery(window).height()/2;
          let tabContent = jQuery("#product-tabs-v2.product-tabs-v3 .tab-content");
          let tabTitle = jQuery("#product-tabs-v2.product-tabs-v3 .tab-title");
          let winTop80 = winTop+82;
          let winTop180 = winTop+162;
        
          tabContent.each(function(){
            var elTop = jQuery(this).offset().top;
            var elBottom = elTop + jQuery(this).height();
            
            if(elTop <= winTop80 && winTop180 < elBottom){
                tabTitle.removeClass("active");
                var dataCr = jQuery(this).attr("data-tab-name");
                jQuery("#product-tabs-v2.product-tabs-v3 .tab-title[data-tab-name="+dataCr+"]").addClass("active");
              
                if(jQuery(window).width() < 768){
                  var totalWidth = jQuery("#product-tabs-v2.product-tabs-v3 .product-tabs-title .tabs-title").outerWidth()
                  jQuery('#product-tabs-v2.product-tabs-v3 .product-tabs-title .tabs-title').css('width', totalWidth);
                  var myScrollPos = jQuery('.tabs-title .tab-title.active').offset().left + jQuery('.tabs-title .tab-title.active').outerWidth(true) / 2 + jQuery('#product-tabs-v2.product-tabs-v3 .tabs-title').scrollLeft() - jQuery('#product-tabs-v2.product-tabs-v3 .tabs-title').width() / 2;
                  jQuery('#product-tabs-v2.product-tabs-v3 .tabs-title').scrollLeft(myScrollPos);
                }
            }
            
          });
      });
  },
  checkCurrentTabsActive: function() {
    let tabTitle = jQuery("#product-tabs-v2 .tab-title");
    let tab_overview = jQuery("#product-tabs-v2 .tab-title[data-tab-name='overview']");
    let has_tab_active = false;
    tabTitle.each(function(){
      if (jQuery(this).hasClass("active")) {
        has_tab_active = true;
      }
      if (!has_tab_active) {
        tab_overview.trigger("click");
      }
    })
  },
  productTabsV2SliderInit: function() {
    
    if (jQuery("#product-tabs-v2 .tabs-title--slider").length > 0) {
      let $productTabsV2Slider = jQuery(".tabs-title--slider");
      let settings = {
        infinite: false,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        responsive: [
          {
             breakpoint: 768,
             settings: {
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
          }
       ]
      };
      $productTabsV2Slider.slick(settings);
    }
  },
  productFAQcountQuestions: function() {
    let desktop_container = jQuery(".product-single__meta--desktop .product-single__plus-info");
    let mobile_container = jQuery(".product-single__meta--mobile .product-single__plus-info");
    let questions = jQuery("#product-tabs-v2 .tab-content[data-tab-name='faqs'] .tab-content--inner strong");
    let count_questions = questions.length;
  
    if (count_questions > 0) {
      let html_desktop = "<span class='wall'>|</span><a href='#faqs' class='product-single__faqs' title='Move to FAQs'><span style='margin-right: 5px;'>" + count_questions + " Questions, </span><span> " + count_questions + " Answers</span></a>"; 
      let html_mobile = "<span class='wall'>|</span><a href='#faqs' class='product-single__faqs' title='Move to FAQs'>View Q&A's</a>"; 
      desktop_container.append(html_desktop);
      mobile_container.append(html_mobile);
      let link = jQuery(".product-single__faqs");
      let tab_faqs = jQuery("#product-tabs-v2 .tab-title[data-tab-name='faqs']");
      let product_info_sticky = jQuery("#product-info--sticky");
      let header_sticky = jQuery(".header-sticky-wrapper");
      link.click(function(e) {
        e.preventDefault();
        tab_faqs.trigger("click");

        if(jQuery(window).width() <= 768) {
          scope.scrollToAnchor_v2(tab_faqs, header_sticky.height() + 15);
          jQuery("#product-tabs-v2 .slick-next").trigger("click");
        }else{
          scope.scrollToAnchor_v2(tab_faqs, product_info_sticky.height() + 15);
        }     
      });
    }
  },
  productReviewsScrollDown() {
    let link = jQuery(".product-single__plus-info .loox-rating");
    let tab_reviews = jQuery("#product-tabs-v2 .tab-title[data-tab-name='reviews']");
    let product_info_sticky = jQuery("#product-info--sticky");
    let header_sticky = jQuery(".header-sticky-wrapper");
    link.click(function(){
      tab_reviews.trigger("click");
      if(jQuery(window).width() <= 768) {
        scope.scrollToAnchor_v2(tab_reviews, header_sticky.height() + 15);
        jQuery("#product-tabs-v2 .slick-next").trigger("click");
      }else{
        scope.scrollToAnchor_v2(tab_reviews, product_info_sticky.height() + 15);
      }
      
    });
  },
  sortContentOverviewTab: function() {
    let overview_content = jQuery("#product-tabs-v2 .tab-content[data-tab-name='overview'] .tab-content__inner");
    let featured_point = jQuery("#product-featured-points");
    let content_height = jQuery("#product-tabs-v2 .tab-content[data-tab-name='overview'] .tab-content--inner").height();
    //target_height = featured_point.height() + 110;
    target_height = 350;
    let readmore = jQuery("#product-tabs-v2 .tab-content[data-tab-name='overview'] .tab-content--inner .read-more");
    
    if (content_height > 350) {
      overview_content.css("height", target_height);
      overview_content.addClass('has-box-readmore hide-content');
      readmore.show();
    } else{
      overview_content.css("height", "auto");
      readmore.hide();
    }
  },
  readMoreOverviewTab: function() {
    let overview_content = jQuery("#product-tabs-v2 .tab-content[data-tab-name='overview'] .tab-content__inner");
    let content_height = jQuery("#product-tabs-v2 .tab-content[data-tab-name='overview'] .tab-content--inner").height();
    let featured_point_height = jQuery("#product-featured-points").height();
    let readmore_btn = jQuery("#product-tabs-v2 .tab-content[data-tab-name='overview'] .tab-content--inner .read-more-btn");
    let viewmoreText = readmore_btn.data("show-more");
    let viewlessText = readmore_btn.data("show-less");
    readmore_btn.click(function(e){
      e.preventDefault();
      if (readmore_btn.hasClass("viewmore")) {
        readmore_btn.removeClass("viewmore");
        //overview_content.css("height", featured_point_height + 110);
        overview_content.css("height", 350);
        overview_content.addClass('hide-content');
        readmore_btn.text(viewmoreText);
      }else{
        readmore_btn.addClass("viewmore");
        overview_content.css("height", "auto");
        overview_content.removeClass('hide-content');
        readmore_btn.text(viewlessText);
      }
    });
  },
  sortContentMobileTab: function() {
    let tab_content = jQuery("#product-tabs-v2.product-tabs-v3 .tab-content");
    tab_content.each(function(){
      let data_tab_content= jQuery(this).data('tab-name');
      if (data_tab_content != "overview" && data_tab_content != "reviews"){
        let inner_tab_content = jQuery("#product-tabs-v2.product-tabs-v3 .tab-content[data-tab-name='"+data_tab_content+"'] .tab-content__inner");
        target_height = 350;
        let inner_tab_content_height = jQuery("#product-tabs-v2.product-tabs-v3 .tab-content[data-tab-name='"+data_tab_content+"'] .tab-content__inner").height();
        let readmore = jQuery("#product-tabs-v2.product-tabs-v3 .tab-content[data-tab-name='"+data_tab_content+"'] .tab-content--inner .read-more");
        if (inner_tab_content_height > 350) {
          inner_tab_content.addClass('has-box-readmore hide-content');
          readmore.show();
        }
      }
    });
  },
  readMoreContentTab: function() {
    let readmore_btn = jQuery("#product-tabs-v2.product-tabs-v3 .tab-content .tab-content--inner .read-more-btn");
    readmore_btn.click(function(e){
      e.preventDefault();
      let show_tab_name = jQuery(this).data("show-tab-name");
      if (show_tab_name != "overview" && show_tab_name != "reviews"){
        let overview_content = jQuery("#product-tabs-v2.product-tabs-v3 .tab-content[data-tab-name='"+show_tab_name+"'] .tab-content__inner");
        let content_height = jQuery("#product-tabs-v2.product-tabs-v3 .tab-content[data-tab-name='"+show_tab_name+"'] .tab-content--inner").height();
        let viewmoreText = jQuery(this).data("show-more");
        let viewlessText = jQuery(this).data("show-less");
        
          if (jQuery(this).hasClass("viewmore")) {
            jQuery(this).removeClass("viewmore");
            overview_content.addClass('hide-content');
            jQuery(this).text(viewmoreText);
            jQuery('html, body').animate({
                  scrollTop: overview_content.offset().top - 120
            }, 200);
          }else{
            jQuery(this).addClass("viewmore");
            overview_content.removeClass('hide-content');
            jQuery(this).text(viewlessText);
          }
      }
    });
  },
  footerPromotionsSliderInit: function () {
    if (jQuery(".footer-promotions--slider").length > 0) {
      let $footerPromotionsSlider = jQuery(".footer-promotions--slider");
      let settings = {
        draggable: true,
        infinite: true,
        slidesToScroll: 3,
        slidesToShow: 3,
        responsive: [
          {
             breakpoint: 768,
             settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
       ]
      };
      $footerPromotionsSlider.slick(settings);
    }
  },
  triggerClickDrawerMenuFooterOnMobile: function() {
    let menu_drawer_footer = jQuery("#footer--pre-menu .footer--pre__drawer-menu");
    let menu_drawer_header = jQuery(".site-header .header-button[aria-controls='NavDrawer']");
    let section_header = jQuery("#shopify-section-header");
    menu_drawer_footer.click(function(e){
      e.preventDefault();
      menu_drawer_header.trigger("click");
      section_header.css("z-index", "29");
    });
  },
  checkContentArea10: function() {
    let area10_section = jQuery("#shopify-section-area10-content");
    let area10_content = jQuery("#a10_article").text();
    if(area10_content == '') {
      area10_section.hide();
    }
  },
  changeFrequentlyBoughtTogetherPosition: function() {
    let isIOS = navigator.userAgent.match(/(iPhone|iPod|iPad)/);
    if(isIOS) {
      jQuery("body").addClass("ios-device");
    }
  },
  frequentlyBoughtUncheckedOnload: function() {
    document.addEventListener("codeblackbelt:frequently-bought-together:rendered", function(){ 
      let input = jQuery(".frequently-bought-together-container .cbb-frequently-bought-selector-input");
      let images = jQuery(".frequently-bought-together-container .cbb-frequently-bought-product")
      input.each(function(){
        if (jQuery(this).is(":checked")) {
          jQuery(this).click();
        }
      });
      images.addClass("unchecked");
    })
  },
  frequentlyBoughtUncheckedEffect: function() {
    let container = document.getElementById("shopify-section-product-template");
    if(container) {
      container.addEventListener("click", function(e){
        let target = e.target;
        let liElement = e.target.parentElement;
        let ulElement = e.target.parentElement.parentElement;
        let liIndex = Array.prototype.indexOf.call(ulElement.children, liElement);
  
        if (target.classList.contains("cbb-frequently-bought-selector-input")){
          let frequentlyBought = container.children[1];
          let images = frequentlyBought.querySelector('.cbb-frequently-bought-products');
          let image = images.children[liIndex];
          if (image.classList.contains("unchecked")) {
            image.classList.remove("unchecked");
          }else{
            image.classList.add("unchecked");
          }
        }
      });
    }
  },
  triggerClickTabDownload() {
    let download_desktop = jQuery("#product-tabs-v2 .product-tabs-download");
    let download_mobile = jQuery("#product-tabs-v2 .tab-download");
    
    download_desktop.click(function(){
      download_mobile.addClass("active");
    });
  
    download_mobile.click(function(){
      download_desktop.addClass("active");
    });
  },
  showHeaderStickyIfScrollUp() {
    let offset = newValue = oldValue = 0;
    let header = document.getElementById("shopify-section-header");
    let topline = document.getElementById("shopify-section-top-line");

    let headerBottomOffset = 0;
    let toplineBottomOffset = 0;

    // add action if template is collection
    let collection_filter = document.getElementsByClassName("collection-filter")[0]; 
    let collection_sidebar = document.getElementsByClassName("grid__item--sidebar")[0];

    // add action if template is product
    let product_tabs_title = document.getElementsByClassName("product-tabs-title")[0];

    // mini cart
    let mini_cart = document.getElementsByClassName('mini-cart')[0];

    window.addEventListener('scroll', function(e){
      if(topline == '' || topline == null) {
        headerBottomOffset = header.offsetHeight;
      }else{
        headerBottomOffset = topline.offsetHeight + header.offsetHeight;
      } 
      // Get the new Value
      newValue = window.pageYOffset;
      offset = newValue - oldValue;
      if(newValue > headerBottomOffset && !header.classList.contains('sticky')) {
        header.classList.add('sticky');
        header.classList.add('hide-header');
        mini_cart.classList.add('hide-header');
        if(collection_filter != undefined) {
          collection_filter.classList.remove("has-header");
        }
        if(product_tabs_title != undefined) {
          product_tabs_title.classList.remove("has-header");
        }

      } else if (newValue <= toplineBottomOffset && header.classList.contains('sticky')){
        header.classList.remove('sticky');
        header.classList.remove('header-animate');
        if(collection_sidebar != undefined) {
          collection_sidebar.style.top = '0px';
        }
      }
      //Subtract the two and conclude
      if(offset > 0 && !header.classList.contains('hide-header') && newValue > headerBottomOffset){
        header.classList.add('hide-header');
        mini_cart.classList.add('hide-header');
        if(product_tabs_title != undefined) {
          product_tabs_title.classList.remove("has-header");
        }
        if(collection_filter != undefined) {
          collection_filter.classList.remove("has-header");
        }
        if(collection_sidebar != undefined) {
          collection_sidebar.style.top = '0px';
        }
      } else if (offset < 0 && header.classList.contains('hide-header')){
        header.classList.remove('hide-header');
        mini_cart.classList.remove('hide-header');
        header.classList.add('header-animate');
        if(product_tabs_title != undefined) {
          product_tabs_title.classList.add("has-header");
        }
        if(collection_filter != undefined) {
          collection_filter.classList.add("has-header");
        }
        if(collection_sidebar != undefined) {
          collection_sidebar.style.top = header.offsetHeight + 'px';
        }
      }
      // Update the old value
      oldValue = newValue;
    });
  },
  initSliderGridItems() {
    let sliders = jQuery('#CollectionSection-v2 .grid-product__image-mask');
    
    for(let i = 0; i < sliders.length; i++) {
      let data_slider = sliders[i].dataset.slider;
      sliders[i].classList.add(data_slider);
      jQuery("."+data_slider).slick({
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000
       });
    }
    
  },
  showSearchOnMobile() {
    
    let search_icon = jQuery('.header-item--search-mobile a');
    let search_bar = jQuery('.header-item--search');
    search_icon.on('click', function(){
      if(!search_bar.hasClass('show')){
        search_bar.addClass('show');
      }
    })
  },
  closeSearchOnMobile() {
    let close = jQuery('.close-search-mobile');
    let search_bar = jQuery('.header-item--search');
    let result_panel = jQuery('.predictive-results');
    close.on('click', function(e){
      e.preventDefault();
      if(!result_panel.hasClass('hide')) {
        result_panel.addClass('hide');
      }
      if(search_bar.hasClass('show')) {
        search_bar.removeClass('show');
      }
    });
  },
  // product-grid-item-new
  clickIconCompare() {
    let label = jQuery('.SPCMP_chk_lbl');
    
    label.on('click', function(e){
      e.preventDefault();
      let input = jQuery(this).siblings(".SPCMP_Add");
      let parent = jQuery(this).parent();
      console.log(jQuery(this));
      if(input.is(':checked')) {
        console.log(jQuery(this));
        input.click();
      }else {
        console.log(jQuery(this));
        input.click();
      }
    });
  },
  clickAddToCart() {
    
    let button = jQuery('.grid__item--new .grid-product__add-to-cart, .pswp__add-to-cart, .sticky__add-to-cart');
    
    button.on('click', function(e){
      e.preventDefault();
      if(!jQuery(this).hasClass('added')) {
        if(jQuery(this).hasClass('grid-product__add-to-cart')) {
          jQuery(this).addClass('added');
        }
        let variant_id = jQuery(this).data('variant');

        let items = [
          {
            'id': variant_id,
            'quantity': 1
          }
        ];

        let upsell = jQuery('.upsell_gps_product_id input');
        if(upsell.length > 0 ) {
          let optional_variant_id = upsell.val();

          items.push({'id': optional_variant_id, 'quantity': 1});
        }

        let formData = {
          'items': items
        };
        theme.cart.addItemFromForm(formData);

        window.addEventListener('cartUpdate', function(){
          
          let site_url = window.location.origin;
          window.location.href = site_url + '/cart';
        });
        
      }
      
    });
  },
  showHelpChoosingPopup() {
    let helpChoosingBtn = jQuery('.help-choosing');
    let popup = jQuery('#help-choosing-popup');
    helpChoosingBtn.click(function(e) {
      e.preventDefault();
      if(popup.hasClass('hide-popup')) {
        popup.removeClass('hide-popup');
      }
    });
  },
  closeHelpChoosingPopup() {
    let closeBtn = jQuery('.help-choosing-close a');
    let popup = jQuery('#help-choosing-popup');
    closeBtn.click(function(e) {
      e.preventDefault();
      if(!popup.hasClass('hide-popup')) {
        popup.addClass('hide-popup');
      }
    });
  },
  reStyleHoneycombUpsell() {
    window.addEventListener('upsellShow', function(){
      let frame = document.getElementById('widget');
      
      let frame_doc = frame.contentWindow.document;
      let frame_body = frame_doc.getElementsByTagName('body')[0];
      frame_body.classList.add('custom-cb-upsell');
      let custom_script = frame_doc.createElement('script');
      custom_script.src = 'https://cdn.shopify.com/s/files/1/0269/5397/3821/t/22/assets/upsell-custom.js?v=144530243985125357881680253872';
      custom_script.type = "text/javascript";
      frame_body.appendChild(custom_script);
    });
  },
  drawerMenuSubLinkGo() {
    let go = jQuery('#NavDrawer .mobile-nav__toggle');
    go.on('click', function(){
      let inner = jQuery(this).parent().siblings();
      if(!inner.hasClass('is-open')) {
        inner.addClass('is-open');
      }
    })
  },
  drawerMenuSubLinkBack() {
    let back = jQuery('#NavDrawer .collapsible-content__back');
    back.on('click', function(){
      let inner = jQuery(this).closest('.mobile-nav__sublist');
      let item = inner.parent();
      let btn = item.find('.mobile-nav__link--button');
      console.log(btn);
      if(inner.hasClass('is-open')) {
        inner.removeClass('is-open');
        btn.removeClass('is-open');
      }
    });
  },
  closeSortpanel() {
    if(!jQuery("body").hasClass('template-collection')) {
      let sort_close = jQuery("#sortby-close");
      sort_close.on("click", function(){
        let sortby_panel = jQuery("#sortby-panel");
        let sortby_overlay = jQuery("#sortby-overlay");
            
        sortby_panel.removeClass("show_panel");
        sortby_overlay.removeClass("active");
      });
      
    }
  },
  customerPanelToggle() {
    let icon = document.getElementsByClassName('customer-icon')[0];
    icon.addEventListener('click', function(e){
   
      if(!e.target.closest('.customer-panel')) {
        e.preventDefault();
        if(e.currentTarget.classList.contains('show')) {
          e.currentTarget.classList.remove('show');
        }else {
          e.currentTarget.classList.add('show')
        }
      }
    });
  }
};

function checkBusinessTime() {
  setInterval(function(){
    window.fcBusinessHours.checkBusinessHours();
  }, 300*1000);
}

function getProductsPCETags() {
  let products = new PCEProduct();
  let data = products.data;
  let tags = [];
  // console.log(data);
  data.forEach(function(product) {
    let product_tags = product['tags'];
    for(let i = 0; i < product_tags.length; i++) {
      tags.push(product_tags[i]);
    }
  });

  let tags_unique = tags.filter((item, i, ar) => ar.indexOf(item) === i);
  
  let label_arr = [];
  
  tags_unique.forEach(function(tag){
    tag_arr = tag.split("_");

    let tag_label = tag_arr[0];
    let tag_value = tag_arr[1];

    label_arr.push(tag_label);
  });
  
  label_arr = label_arr.filter((item, i, ar) => ar.indexOf(item) === i);
   
  let html = '';

  for(let i = 0; i < label_arr.length; i++) {
    html += '<div class="pce-sidebar__group pce-sidebar__group--'+ label_arr[i] +'"';
      html += '<button type="button" class="collapsible-trigger collapsible-trigger-btn">'+ label_arr[i] +'</buton>';
      html += '<ul class="tag-list tag-list--checkboxes">';
      for(let j = 0; j < tags_unique.length; j++) {
        let tag_arr = tags_unique[j].split("_");

        let tag_label = tag_arr[0];
        let tag_value = tag_arr[1];

        if(tag_label == label_arr[i]) {
          html += '<li class="tag">'+ tag_value +'</li>';
        }
      }

      html += '</ul>';
    html += '</div>';
  }
  

  let sidebar_container = jQuery('#shopify-section-pce-products .grid__item--sidebar');
  sidebar_container.append(html);
}
function check_wishlist() {
  mainMenu = jQuery('.header-wrapper .mobile-nav, .header-wrapper .site-nav__icons');

  let wishListItem = mainMenu.find('.wishlist');
  let wishListNumber = mainMenu.find('.number-wishlist');
  let wishList = new WishList();
  
  let productsWishList = wishList.getWishListProducts();
  
  
  if(productsWishList.length > 0) {
    wishListNumber.text(productsWishList.length);
    if(wishListItem.length > 0) {
      wishListItem.addClass('show');
    } 
    else {
      let wishListItemHTML = '<li class="site-nav__item site-nav__expanded-item wishlist show">'
                            + '<a href="https://thespystore.com.au/pages/favorites">'
                              + '<span class="number-wishlist">'+ productsWishList.length +'</span>'
                              + '<svg class="icon-wishlist" xmlns="http://www.w3.org/2000/svg" width="28.955" height="29.117" viewBox="0 0 33.955 31.117">'
                                + '<g id="Layer_2" data-name="Layer 2" transform="translate(0.768 0.768)">'
                                  + '<g id="Layer">'
                                    + '<path id="_17_wishlist" data-name="17_wishlist" d="M30.6,3.819c-6.343-6.343-13.39,0-13.39,0s-7.047-6.343-13.39,0c0,0-6.343,7.047,0,13.39L17.209,30.6,30.6,17.209C36.942,10.866,30.6,3.819,30.6,3.819Z" transform="translate(-1 -1)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>'
                                  + '</g>'
                                + '</g>'
                              + '</svg>'
                            + '</a>'
                          + '</li>';
      mainMenu.append(wishListItemHTML);
    } 
  }
  
}

jQuery(document).ready(function () {
  // checkBusinessTime();
  check_wishlist();
  scope.init();
  // getProductsPCETags();
  $(document).on('shopify:section:load', function (e) {
    if (e.target.classList.contains("featured-collection")) {
      scope.featuredCollectionSliderInit();
    }
  })
});

let slideUp = (element) => {
  var duration = 500;

  return new Promise(function (resolve, reject) {

    element.style.height = element.offsetHeight + 'px';
    element.style.transitionProperty = `height, margin, padding`;
    element.style.transitionDuration = duration + 'ms';
    element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    window.setTimeout(function () {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');
      resolve(false);
    }, duration)
  })
}

let slideDown = (element) => {
  var duration = 500;

  return new Promise(function (resolve, reject) {

    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;

    if (display === 'none')
      display = 'block';

    element.style.display = display;
    let height = element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    element.offsetHeight;
    element.style.transitionProperty = `height, margin, padding`;
    element.style.transitionDuration = duration + 'ms';
    element.style.height = height + 'px';
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');
    window.setTimeout(function () {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');
    }, duration)
  })
}

class Accordion_Accordion {

  constructor ($root, options) {
    this.optionsDefault = {
      accordionTitleSelector: '.questions__question',
      accordionContentSelector: '.questions__answer',
      activeClass: 'active',
      multipleExpand: false,
      duration: 300
    }
    this.options = {}
    this.$root = $root;
    this.options = Object.assign(this.optionsDefault, options);

    this.init = () => {
      this.$titles.forEach(
        ($el) => {
          $el.addEventListener("click", this.toggleBindEvent);
        }
      );

      this.$root.classList.add(this.options.initClass);
    }

    this.destroy = () => {
      this.$titles.forEach(
        ($el) => {
          $el.classList.remove(this.options.activeClass);
          $el.removeEventListener("click", this.toggleBindEvent);
          $el.nextElementSibling.style.height = null;
          $el.nextElementSibling.removeAttribute('style');
        }
      );

      this.$root.classList.remove(this.options.initClass);
    }

    this.toggle = (evt) => {

      evt.preventDefault();
      this.currentTarget = evt.currentTarget;

      if (!this.options.multipleExpand) {
        this.closeAll(); // exclude current target
      }

      if (this.currentTarget.classList.contains(this.options.activeClass)) {
        this.close();
      }
      else {
        this.open()
      }
    }

    this.closeAll = () => {
      this.$titles.forEach(
        ($el) => {
          if (!$el.isSameNode(this.currentTarget) && this.isOpened($el)) {
            this.close($el);
          }
        }
      );
    }

    this.isOpened = ($el) => {
      return $el.classList.contains(this.options.activeClass);
    }

    this.close = ($el) => {
      if (typeof $el == "undefined") {
        $el = this.currentTarget;
      }

      slideUp($el.nextElementSibling);
      $el.classList.remove(this.options.activeClass);
      $el.setAttribute("aria-expanded", "false")
    }

    this.open = ($el) => {
      if (typeof $el == "undefined") {
        $el = this.currentTarget;
      }

      slideDown($el.nextElementSibling);
      $el.classList.add(this.options.activeClass);
      $el.setAttribute("aria-expanded", "true")
    }

    this.$titles = this.$root.querySelectorAll(this.options.accordionTitleSelector);
    this.toggleBindEvent = this.toggle.bind(this);
  }
}


class CollectionFAQs extends HTMLElement{
  constructor(){
    super();

    this.questionTags = "H2";
    this.faqGroups = [];

    this.init();
  }

  init(){

    let index = 0;
    let childCount = this.childElementCount;
    let group, answer, groups;

    while(this.childElementCount > 0){
      let node = this.children[0];
  
      // console.log(node.tagName, index++);
  
      if(this.questionTags.indexOf(node.tagName) !== -1){
        // this is a heading (question)
            
        group = this.createGroup();
        answer = this.createAnswer();
        let question = this.createQuestion(node);
        group.append(question, answer); // add question to top of group and next is answer wrapper;

        this.faqGroups.push(group);
      }
      else{
        // this is a content tag
        if(node.innerText.trim() == ""){
          node.remove();
        }
        else{ 
          answer.append(node); // add a part of answer 
        }
      }

      if(index >= childCount) break;

    }

    groups = document.createElement("div");
    groups.classList.add("faq-groups");

    for(let i = 0; i < this.faqGroups.length; i++) {
      groups.append(this.faqGroups[i])
    }

    this.append(groups);

    let accordion = new Accordion_Accordion(groups, { multipleExpand: false });
    accordion.init();
  }

  createGroup(){
    let group = document.createElement("div");
    group.classList.add("faq-group");

    return group;
  }

  addQuestion(group, question){
    group.append(question);
  }

  addAnswer(group, answer){
    group.append(answer);
  }

  createQuestion(question){
    let questionNode = document.createElement("h2");
    
    questionNode.classList.add("questions__question");
    questionNode.innerText = question.innerText;

    let icon = document.createElement("i");
    icon.classList.add("icon");

    questionNode.append(icon);

    question.remove(); // it should remove to make all question has h2 tag

    return questionNode;
  }

  createAnswer(){
    let answerWrapper = document.createElement("div");
    answerWrapper.classList.add("questions__answer");

    return answerWrapper;
  }


}

customElements.define("collection-faqs", CollectionFAQs);

class WishList {
  constructor() {
    this.WISHLIST_COUNT = 12;
    this.WISHLIST_LOCAL_STORAGE_KEY = 'wishlistProductsInfo';
    this.PLACEHOLDER = 'PLACEHOLDER';
    this.WISHLIST_ADDED_CLASS = 'wishlist--added';
    this.WISHLIST_TOGGLE_CONTAINER_CLASS = 'wishlist__actions';
    this.WISHLIST_ADD_MESSAGE = 'Click here to add product to wishlist';
    this.WISHLIST_REMOVE_MESSAGE = 'Click here to remove product to wishlist';
  }
  

  addWishList(productHandle, productTitle, productTags, productPrice) {
    var wishListJSON = null;

    if (this.isLocalStorageSupported()) {
      wishListJSON = localStorage.getItem(this.WISHLIST_LOCAL_STORAGE_KEY);
    }

    var _wishList = wishListJSON != null ? JSON.parse(wishListJSON) : [];

    var item = {
      'handle': productHandle,
      'title': productTitle,
      'tags': productTags,
      'price': productPrice
    };

    _wishList.unshift(item);

    var uniqueArray = _wishList.length ? this.get_unique_array(_wishList) : _wishList;

    // if (uniqueArray.length > this.WISHLIST_COUNT) {
    //   uniqueArray = uniqueArray.slice(0, this.WISHLIST_COUNT);
    // }

    if (this.isLocalStorageSupported()) {
      localStorage.setItem(this.WISHLIST_LOCAL_STORAGE_KEY, JSON.stringify(uniqueArray));
    }
  }

  removeWishList(productHandle) {
    var wishListJSON = null;

    if (this.isLocalStorageSupported()) {
      wishListJSON = localStorage.getItem(this.WISHLIST_LOCAL_STORAGE_KEY);
    }

    var _wishList = wishListJSON != null ? JSON.parse(wishListJSON) : [];

    var handleList = _wishList.map(function (a) { return a.handle; });
    var indexHandle = handleList.indexOf(productHandle);

    if (indexHandle > -1) {
      _wishList.splice(indexHandle, 1);
    }

    if (this.isLocalStorageSupported()) {
      localStorage.setItem(this.WISHLIST_LOCAL_STORAGE_KEY, JSON.stringify(_wishList));
    }
  }

  isWishList(productHandle) {
    var wishListJSON = null;

    if (this.isLocalStorageSupported()) {
      wishListJSON = localStorage.getItem(this.WISHLIST_LOCAL_STORAGE_KEY);
    }

    var _wishList = wishListJSON != null ? JSON.parse(wishListJSON) : [];

    var handleList = _wishList.map(function (a) { return a.handle; });
    return handleList.indexOf(productHandle) > -1;
  }

  getWishListProducts(){
    var wishListJSON = localStorage.getItem(this.WISHLIST_LOCAL_STORAGE_KEY);
    return wishListJSON != null ? JSON.parse(wishListJSON) : [];
  }

  isLocalStorageSupported() {
    try {
      return typeof Storage != "undefined" && window.localStorage && window.sessionStorage ? true : false;
    } catch (e) {
      return false;
    }
  }

  get_unique_array(array) {
    var newArray = new Array();
    var handleArray = new Array();

    for (var i = 0; i < array.length; i++) {
      var handle = array[i]['handle'];

      if (handleArray.indexOf(handle) === -1) {
        newArray.push(array[i]);
        handleArray.push(handle);
      }
    }

    return newArray;
  }
}

class Wishlist_Toggler extends HTMLElement{
  constructor(){
    super();
    this.wishList = new WishList();
    if(!this.wishList.isLocalStorageSupported()){
      return
    }
    
    this.productHandle = this.dataset.productHandle;
    this.productTitle = this.dataset.productTitle;
    this.productTags = this.dataset.productTags;
    this.productPrice = this.dataset.productPrice;
    

    this.addEventListener("click", this.clickCallback.bind(this));

    if(this.wishList.isWishList(this.productHandle)){
      this.classList.add(this.wishList.WISHLIST_ADDED_CLASS);
    }
  }

  clickCallback(e) {
    e.preventDefault();

    if(this.classList.contains(this.wishList.WISHLIST_ADDED_CLASS)){
      this.wishList.removeWishList(this.productHandle);
      this.classList.remove(this.wishList.WISHLIST_ADDED_CLASS);
      this.title = this.wishList.WISHLIST_ADD_MESSAGE;
    }
    else{
      this.wishList.addWishList(this.productHandle, this.productTitle, this.productTags, this.productPrice);
      this.classList.add(this.wishList.WISHLIST_ADDED_CLASS);
      this.title = this.wishList.WISHLIST_REMOVE_MESSAGE
    }
    check_wishlist();
    return false;
  }
}
customElements.define('wishlist-add', Wishlist_Toggler);

class Wishlist_Wrapper extends HTMLElement{
  constructor(){
    super();
    this.wishList = new WishList();
    if(!this.wishList.isLocalStorageSupported()){
      return
    }
    this.progress = 0;
    this.parser = new DOMParser();
    this.productsList = this.wishList.getWishListProducts();

    this.data = [];

    this.perRow = this.dataset.row;
    this.limit = this.dataset.limit;
    
    this.tagsFilter = [];

    this.tagListActive = document.querySelectorAll('#CollectionSidebar-v2 .tag-list--active-tags');

    this.currentPage = 1;
    
    this.productUrl = this.dataset.producturl;
    
    this.productsContainer = this.getElementsByClassName('products-container')[0];
    
    this.placeholder = this.getElementsByClassName("grid__item--placeholder")[0];

    this.sortType = 'title-ascending';

    this.btnOpenFilterMobile = document.getElementsByClassName('js-drawer-open-collection-filters')[0];
    this.btnOpenFilterText = this.btnOpenFilterMobile.querySelector(".btn-filter-text");
    
    this.sortSelect = document.getElementById('SortBy');
    this.sortSelect.addEventListener('click', this.showSortList.bind(this));

    this.sortItems = document.querySelectorAll('#sortby-panel .sortby-list .sortby-item ');
    Array.from(this.sortItems).forEach(function(element){
      element.addEventListener("click", this.sortHandler.bind(this));
    }, this);

    if(this.productsList.length == 0){
      this.classList.add("no-product");
    }

    this.render();
    // this.createPagination();

    this.filterContainer = document.getElementsByClassName('grid__item--sidebar')[0];
    this.filterItems = this.filterContainer.querySelectorAll('.tag span');
    this.checkFilterItems();
    Array.from(this.filterItems).forEach(function(element){
      element.addEventListener("click", this.getTagsFilter.bind(this));
    }, this);
  }
  checkFilterItems() {
    let allTags = [];
    for(let i = 0; i < this.productsList.length; i++) {
        let productTags = this.productsList[i]['tags'];
        
        let productTagsArr = [];
        if(productTags != undefined) {
          productTagsArr = productTags.split(',');
        } 
        allTags = allTags.concat(productTagsArr);
    }
    
    Array.from(this.filterItems).forEach(function(element){
      let tagName = element.dataset.tag;
      let text = element.innerText;
      let parent = element.parentElement;
      
      if(!allTags.includes(tagName)) {
        parent.remove();
      }else {
        let counts = [];
        allTags.forEach(function (x) { counts[x] = (counts[x] || 0) + 1; });
        let newText = text + ' (' + counts[tagName] + ')';

        element.innerText = newText;
      }
      
    }, this);

    let ul_elements = document.getElementsByClassName("tag-list--order");
    Array.from(ul_elements).forEach(function(ul){
      if(ul.children.length < 1) {
        let group = ul.parentElement.parentElement.parentElement;
  
        group.style.display = "none";
      }
    });
    
  }

  removeWishList(handle){
    this.wishList = new WishList();
    this.wishList.removeWishList(handle);
  }
  render(resetCurrentPage = false){
    if(resetCurrentPage) {
      this.currentPage = 1;
    }
    let productPerPage = this.limit;
    let end_index = this.currentPage * productPerPage;
    let start_index = end_index - productPerPage;

    if(this.tagsFilter.length < 1) {
      while (this.productsContainer.firstChild) this.productsContainer.removeChild(this.productsContainer.firstChild);
      this.data = this.productsList;
      if(this.data.length > 0) {
        
        this.data = this.formatData(this.sortType, this.data);
        
        let stop_index = 0;
        if(this.data.length > (this.currentPage*productPerPage)) {
          stop_index = end_index
        }else{
          stop_index = this.data.length;
        }
        if(this.currentPage > 1) {
          this.productsContainer.style.height = this.containerHeight + 'px';
        }
        this.progress = 0;
        
        this.loadProductsGrid(start_index, stop_index);
      }else {
        let notfound = '<p>Sorry, there are no products in favorites.</p>';
        this.productsContainer.innerHTML = notfound;
      }

    }else {
      this.data = [];
      for (let i = 0; i < this.productsList.length; i++) {
        let productTags = this.productsList[i]['tags'];
        let productTagsArr = [];
        if(productTags != undefined) {
          productTagsArr = productTags.split(',');
        } 
        
        let is_passed = false;
        for(let j = 0; j < this.tagsFilter.length; j++) {
          
          if(productTagsArr.includes(this.tagsFilter[j])) {
            is_passed = true;
          }
        }
        if(is_passed) {
          this.data.push(this.productsList[i]);
        }
      }
      

      while (this.productsContainer.firstChild) this.productsContainer.removeChild(this.productsContainer.firstChild);
      if(this.data.length > 0) {
        let stop_index = 0;
        if(this.data.length > (this.currentPage*productPerPage)) {
          stop_index = end_index
        }else{
          stop_index = this.data.length;
        }

        if(this.currentPage > 1) {
          this.productsContainer.style.height = this.containerHeight + 'px';
        }
        this.progress = 0;
        this.loadProductsGrid(start_index, stop_index);
        
      }else{
        let notfound = '<p>Sorry, there are no products in this tags.</p>';
        this.productsContainer.innerHTML = notfound;
      }
      
    }

    let pagination = this.productsContainer.parentElement.getElementsByClassName('pagination')[0];
    if(pagination != undefined) {
      this.productsContainer.parentElement.removeChild(pagination);
    }
    if(this.data.length > this.limit) {
      this.createPagination(this.data);
    }
  }

  loadProductsGrid(start, stop){
    let number_product = stop - start;
    this.data = this.formatData(this.sortType, this.data);
    for(let i = start; i < stop; i++) {
      let url = window.location.origin + '/products/' + this.data[i].handle + "?view=grid-item-new";
      
      fetch(url)
      .then((res) => {
        if(res.status == 404){
          this.removeWishList(this.data[i].handle);
        }
        return res.text();
      })
      .then(res => this.showProduct(res, i, number_product))
      .catch(err => console.log(err));
    }
  }

  /* The function does not called anywhere */
  loadProducts(data){
    data.map(function (rv) {
      try {
        let url = this.productUrl.replace(this.wishList.PLACEHOLDER, rv.handle);
        
        fetch(url)
          .then(response => response.text())
          .then(result => {
            this.showProduct(result);
            
            this.classList.add("has-product")
          })
          .catch(error => {
            console.log(error);
          });;
      }
      catch (e) {
        return { status: 404, responseText: e.message }
      }
    }.bind(this));

  }

  showProduct(res, i, number_product){
    this.progress++;
    
    let doc = this.parser.parseFromString(res, 'text/html');
    let product = doc.querySelector(".grid-product");

    let layout = '';
    let items_layout = document.getElementsByClassName('item-layout');
    for(let i = 0; i < items_layout.length; i++) {
      if(items_layout[i].classList.contains('active')) {
        layout = items_layout[i].dataset.layout;
      }
    }

    product.style.display = 'flex';
    product.style.order = i + 1;
    product.classList.add(layout + '-active');

    
    this.productsContainer.append(product);

    if(this.progress == number_product) {
      this.productsContainer.setAttribute('style', '');
      this.scrollToTop();
    }
  }

  createPagination(data = []) {
        
    if(data.length > 0) {
      this.totalPage = data.length / this.limit;
    }else{
      this.totalPage = this.data.length / this.limit;
    }
    
    if(!Number.isInteger(this.totalPage ) || this.totalPage == 0) {
      this.totalPage += 1;
    }
    
    
    let pagination = document.createElement('div');
    pagination.classList.add('pagination');

    let html = '';
    if(this.currentPage > 1 && this.totalPage > 1) {
      html += '<span class="page prev">';
        html += '<a href="'+ window.location.href +'?page='+ (parseFloat(this.currentPage) - 1) +'" data-page="'+ (parseFloat(this.currentPage) - 1) +'">';
          html += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg>';
        html += '</a>';
      html += '</span>';
    }
    
    for(let i = 1; i <= this.totalPage; i++) {
      if(this.currentPage == i) {
        html += '<span class="page current">'+ i +'</span>';
      }else{
        html += '<span class="page"><a href="'+ window.location.href +'?page=' + i + '" data-page="'+ i +'">'+ i +'</a></span>';
      }
    }
    if(this.currentPage < parseInt(this.totalPage)) {
      html += '<span class="page next">';
        html += '<a href="'+ window.location.href +'?page='+ (parseFloat(this.currentPage) + 1) +'" data-page="'+ (parseFloat(this.currentPage) + 1) +'">';
          html += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg>';
        html += '</a>';
      html += '</span>';
    }
    pagination.innerHTML = html;

    this.productsContainer.parentElement.appendChild(pagination);

    let pagination_item = pagination.querySelectorAll('.page a');
    Array.from(pagination_item).forEach(function(element){
      element.addEventListener("click", this.actionPagination.bind(this));
    }, this);

  }

  actionPagination(e) {
    e.preventDefault();
    
    
    this.currentPage = e.target.closest('a').dataset.page;
    
    
    let current_height = this.productsContainer.offsetHeight;
    this.containerHeight = current_height;
    
    this.render();
    
  }

  getTagsFilter(e) {
      
    let tag = e.target.dataset.tag;
   
    Array.from(this.filterItems).forEach(function(element){
      
      let tag_e = element.dataset.tag;
      let parent_e = element.parentElement;
      if(parent_e.classList.contains('tag--active') && tag_e == tag) {
        parent_e.classList.remove('tag--active');
        this.removeRedTag(tag);
        let index = this.tagsFilter.indexOf(tag);
        if (index !== -1) {
          this.tagsFilter.splice(index, 1);
        }
      }else if (!parent_e.classList.contains('tag--active') && tag_e == tag) {
        
        parent_e.classList.add('tag--active');

        let is_added = false;
        let tagListActiveItems = document.querySelectorAll('.tag--remove');
        
        if(tagListActiveItems.length > 0) {
          Array.from(tagListActiveItems).forEach(function(item){
            if(item.dataset.tag == tag) {
              is_added = true;
            }
          }, this);
        }
        if(!is_added) {
          this.addRedTag(tag);
        }
        
        if(!this.tagsFilter.includes(tag)) {
          this.tagsFilter.push(tag);
        }
      }
      this.btnOpenFilterText.innerText = 'Filter (' + this.tagsFilter.length + ')';
    }, this);

    if (this.tagsFilter.length > 0 && !this.btnOpenFilterMobile.classList.contains('btn--tertiary-active')) {
      this.btnOpenFilterMobile.classList.add('btn--tertiary-active');
    } else if (this.tagsFilter.length < 1){
      this.btnOpenFilterMobile.classList.remove('btn--tertiary-active');
      this.btnOpenFilterText.innerText = 'Filter';
    }
    
    this.data = [];
    
    this.render(true);
    if (theme.FilterDrawer) {
      theme.FilterDrawer.close();
    }
  }
  addRedTag(tag) {
    let tag_arr = tag.split('_');
    
    let html = '<span class="btn btn--small js-no-transition" title="Remove tag '+ tag +'">'+ tag_arr[1] +'</span>';
    html += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg>';

    let li_element = document.createElement('li');
    li_element.classList.add('tag','tag--remove');
    li_element.dataset.tag = tag;
    li_element.innerHTML = html;

    

    Array.from(this.tagListActive).forEach(function(ul){
      
      let duplicatedE = li_element.cloneNode(true);
      ul.appendChild(duplicatedE);

      this.actionRemoveRedTag(duplicatedE);
    }.bind(this));

  }

  removeRedTag(tag) {
  
    Array.from(this.tagListActive).forEach(function(ul){
      
      let tags_remove = ul.getElementsByTagName('li');
      for(let i = 0; i < tags_remove.length; i++) {
        if(tags_remove[i].dataset.tag == tag) {
          ul.removeChild(tags_remove[i]);
        }
      }
    }.bind(this));
    
  }

  actionRemoveRedTag(element) {
    let redTag = element.querySelector('span');
    redTag.addEventListener("click", function(e){
      
      let tag_remove = redTag.parentElement.dataset.tag;
        
      let index = this.tagsFilter.indexOf(tag_remove);
      if (index !== -1) {
        this.tagsFilter.splice(index, 1);
      }
      this.removeRedTag(tag_remove);

      
      Array.from(this.filterItems).forEach(function(item){
        let tag = item.dataset.tag;
        if(tag == tag_remove && item.parentElement.classList.contains('tag--active')) {
          item.parentElement.classList.remove('tag--active');
        }
      });
      if (this.tagsFilter.length < 1){
        this.btnOpenFilterMobile.classList.remove('btn--tertiary-active');
        this.btnOpenFilterText.innerText = 'Filter';
      } else {
        this.btnOpenFilterText.innerText = 'Filter (' + this.tagsFilter.length + ')';
      }
      this.data = [];
      this.render();
    }.bind(this));
  }

  showSortList(e) {
    e.preventDefault();
    let sortby_panel = document.getElementById("sortby-panel");
    let sortby_overlay = document.getElementById("sortby-overlay");
    if(sortby_panel.classList.contains("show_panel")) {
      sortby_panel.classList.remove("show_panel");
      sortby_overlay.classList.remove("active");
    }else{
      sortby_panel.classList.add("show_panel");
      sortby_overlay.classList.add("active");  
    }
  
  }

  sortHandler(e) {
    e.preventDefault();
    let li_element = e.currentTarget;
    let a_element = li_element.querySelector('a');
    
    let value = a_element.dataset.value;
    let item_name = '';
    Array.from(this.sortItems).forEach(function(item){
      let a_item = item.querySelector('a');
      if(a_item.dataset.value == value && !item.classList.contains("sortby-item--selected")) {
        item.classList.add("sortby-item--selected");
        item_name = item.getElementsByClassName('sortby-item-name')[0].innerText;
      }else{
        item.classList.remove("sortby-item--selected");
      }
    }, this);
    this.sortType = value;
    let current_sortby = this.sortSelect.getElementsByClassName('current-sortby')[0];
    current_sortby.innerText = 'Sort: ' + item_name;
    this.render();
    let sortby_panel = document.getElementById("sortby-panel");
    let sortby_overlay = document.getElementById("sortby-overlay");
    if(sortby_panel.classList.contains("show_panel")) {
      sortby_panel.classList.remove("show_panel");
      sortby_overlay.classList.remove("active");
    }
  }

  formatData(type, data) {
    switch (type) {
      case 'title-ascending':
        data.sort((a, b) => a.title.localeCompare(b.title) || b.price - a.price);
        break;
      case 'title-descending':
        data.sort((a, b) => b.title.localeCompare(a.title) || b.price - a.price);
        break;
      case 'price-ascending':
        data.sort((a, b) => a.price - b.price);
        break;
      default:
        data.sort((a, b) => b.price - a.price);
        break;
    }
    return data;
  }

  scrollToTop() {
    let scrollHeight = this.productsContainer.offsetTop;
    window.scrollTo({ top: scrollHeight - 200, behavior: 'smooth'}); 
  }
}
customElements.define("wishlist-wrapper", Wishlist_Wrapper);

class Search_Wrapper extends HTMLElement{
  constructor(){
    super();

    this.perRow = this.dataset.row;
    this.limit = this.dataset.limit;
    this.productsExclude = this.dataset.excludes.split(',');

    this.progress = 0;
    this.parser = new DOMParser();

    this.productsList = window.search_results;
    this.resultNumber = this.productsList.length;
    this.data = [];
    this.resultTextBreadcrumb = document.getElementsByClassName('search_results_number')[0];
    this.excludeProducts();
    
    
    this.tagsFilter = [];

    this.tagListActive = document.querySelectorAll('#CollectionSidebar-v2 .tag-list--active-tags');

    this.currentPage = 1;
    
    this.productUrl = this.dataset.producturl;
    
    this.productsContainer = this.getElementsByClassName('products-container')[0];
    
    this.placeholder = this.getElementsByClassName("grid__item--placeholder")[0];

    this.sortType = 'title-ascending';

    this.btnOpenFilterMobile = document.getElementsByClassName('js-drawer-open-collection-filters')[0];
    this.btnOpenFilterText = this.btnOpenFilterMobile.querySelector(".btn-filter-text");
    
    this.sortSelect = document.getElementById('SortBy');
    this.sortSelect.addEventListener('click', this.showSortList.bind(this));

    this.sortItems = document.querySelectorAll('#sortby-panel .sortby-list .sortby-item ');
    Array.from(this.sortItems).forEach(function(element){
      element.addEventListener("click", this.sortHandler.bind(this));
    }, this);

    if(this.productsList.length == 0){
      this.classList.add("no-product");
    }

    this.render();
    // this.createPagination();

    this.filterContainer = document.getElementsByClassName('grid__item--sidebar')[0];
    this.filterItems = this.filterContainer.querySelectorAll('.tag span');
    this.checkFilterItems();
    Array.from(this.filterItems).forEach(function(element){
      element.addEventListener("click", this.getTagsFilter.bind(this));
    }, this);
  }
  checkFilterItems() {
    let allTags = [];
    for(let i = 0; i < this.productsList.length; i++) {
        let productTags = this.productsList[i]['tags'];
        allTags = allTags.concat(productTags);
    }
    
    Array.from(this.filterItems).forEach(function(element){
      let tagName = element.dataset.tag;
      let text = element.innerText;
      let parent = element.parentElement;
      
      if(!allTags.includes(tagName)) {
        parent.remove();
      }else {
        let counts = [];
        allTags.forEach(function (x) { counts[x] = (counts[x] || 0) + 1; });
        let newText = text + ' (' + counts[tagName] + ')';

        element.innerText = newText;
      }
      
    }, this);

    let ul_elements = document.getElementsByClassName("tag-list--order");
    Array.from(ul_elements).forEach(function(ul){
      if(ul.children.length < 1) {
        let group = ul.parentElement.parentElement.parentElement;
  
        group.style.display = "none";
      }
    });
    
  }
  render(resetCurrentPage = false){
    if(resetCurrentPage) {
      this.currentPage = 1;
    }
    let productPerPage = this.limit;
    let end_index = this.currentPage * productPerPage;
    let start_index = end_index - productPerPage;

    if(this.tagsFilter.length < 1) {
      while (this.productsContainer.firstChild) this.productsContainer.removeChild(this.productsContainer.firstChild);
      this.data = this.productsList;
      this.data = this.formatData(this.sortType, this.data);
      
      let stop_index = 0;
      if(this.data.length > (this.currentPage*productPerPage)) {
        stop_index = end_index
      }else{
        stop_index = this.data.length;
      }
      if(this.currentPage > 1) {
        this.productsContainer.style.height = this.containerHeight + 'px';
      }
      this.progress = 0;
      let number_product = stop_index - start_index;
      for(let i = start_index; i < stop_index; i++) {
        let url = window.location.origin + '/products/' + this.data[i].handle + "?view=grid-item-new";
        
        fetch(url)
        .then(res => res.text())
        .then(res => this.showProduct(res, i, number_product));
      }
      
    }else {
      this.data = [];
      for (let i = 0; i < this.productsList.length; i++) {
        let productTags = this.productsList[i]['tags'];
        
        
        let is_passed = false;
        for(let j = 0; j < this.tagsFilter.length; j++) {
          
          if(productTags.includes(this.tagsFilter[j])) {
            is_passed = true;
          }
        }
        if(is_passed) {
          this.data.push(this.productsList[i]);
        }
      }
      

      while (this.productsContainer.firstChild) this.productsContainer.removeChild(this.productsContainer.firstChild);
      if(this.data.length > 0) {
        let stop_index = 0;
        if(this.data.length > (this.currentPage*productPerPage)) {
          stop_index = end_index
        }else{
          stop_index = this.data.length;
        }

        if(this.currentPage > 1) {
          this.productsContainer.style.height = this.containerHeight + 'px';
        }
        this.progress = 0;
        let number_product = stop_index - start_index;
        
        this.data = this.formatData(this.sortType, this.data);
        
        for(let j = start_index; j < stop_index; j++) {
          if(this.data[j].handle != undefined) {
            let url = window.location.origin + '/products/' + this.data[j].handle + "?view=grid-item-new";
           
            fetch(url)
            .then(res => res.text())
            .then(res => this.showProduct(res, j, number_product));
          }
        }
        
      }else{
        let notfound = '<p class="grid__item">Sorry, there are no products in this tags.</p>';
        this.productsContainer.innerHTML = notfound;
      }
      
    }
    let pagination = this.productsContainer.parentElement.getElementsByClassName('pagination')[0];
    if(pagination != undefined) {
      this.productsContainer.parentElement.removeChild(pagination);
    }
    if(this.data.length > this.limit) {
      this.createPagination(this.data);
    }
  }
  checkHasExclude(handle) {
    if(this.productsExclude.includes(handle)) {
      return true;
    }
    return false;
  }
  loadProducts(data){
    data.map(function (rv) {
      try {
        let url = this.productUrl.replace(this.wishList.PLACEHOLDER, rv.handle);
        
        fetch(url)
          .then(response => response.text())
          .then(result => {
            this.showProduct(result);
            
            this.classList.add("has-product")
          })
          .catch(error => {
            console.log(error);
          });;
      }
      catch (e) {
        return { status: 404, responseText: e.message }
      }
    }.bind(this));

  }

  showProduct(res, i, number_product){
    this.progress++;
    
    let doc = this.parser.parseFromString(res, 'text/html');
    let product = doc.querySelector(".grid-product");

    let layout = '';
    let items_layout = document.getElementsByClassName('item-layout');
    for(let i = 0; i < items_layout.length; i++) {
      if(items_layout[i].classList.contains('active')) {
        layout = items_layout[i].dataset.layout;
      }
    }

    product.style.display = 'flex';
    product.style.order = i + 1;
    product.classList.add(layout + '-active');

    
    this.productsContainer.append(product);

    if(this.progress == number_product) {
      this.productsContainer.setAttribute('style', '');
      this.scrollToTop();
    }
  }

  createPagination(data = []) {
        
    if(data.length > 0) {
      this.totalPage = data.length / this.limit;
    }else{
      this.totalPage = this.data.length / this.limit;
    }
    
    if(!Number.isInteger(this.totalPage ) || this.totalPage == 0) {
      this.totalPage += 1;
    }
    
    
    let pagination = document.createElement('div');
    pagination.classList.add('pagination');

    let html = '';
    if(this.currentPage > 1 && this.totalPage > 1) {
      html += '<span class="page prev">';
        html += '<a href="'+ window.location.href +'?page='+ (parseFloat(this.currentPage) - 1) +'" data-page="'+ (parseFloat(this.currentPage) - 1) +'">';
          html += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg>';
        html += '</a>';
      html += '</span>';
    }
    
    for(let i = 1; i <= this.totalPage; i++) {
      if(this.currentPage == i) {
        html += '<span class="page current">'+ i +'</span>';
      }else{
        html += '<span class="page"><a href="'+ window.location.href +'?page=' + i + '" data-page="'+ i +'">'+ i +'</a></span>';
      }
    }
    if(this.currentPage < parseInt(this.totalPage)) {
      html += '<span class="page next">';
        html += '<a href="'+ window.location.href +'?page='+ (parseFloat(this.currentPage) + 1) +'" data-page="'+ (parseFloat(this.currentPage) + 1) +'">';
          html += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg>';
        html += '</a>';
      html += '</span>';
    }
    pagination.innerHTML = html;

    this.productsContainer.parentElement.appendChild(pagination);

    let pagination_item = pagination.querySelectorAll('.page a');
    Array.from(pagination_item).forEach(function(element){
      element.addEventListener("click", this.actionPagination.bind(this));
    }, this);

  }
  actionPagination(e) {
    e.preventDefault();
    
    
    this.currentPage = e.target.closest('a').dataset.page;
    
    
    let current_height = this.productsContainer.offsetHeight;
    this.containerHeight = current_height;
    
    this.render();
    
  }
  getTagsFilter(e) {
      
    let tag = e.target.dataset.tag;
   
    Array.from(this.filterItems).forEach(function(element){
      
      let tag_e = element.dataset.tag;
      let parent_e = element.parentElement;
      if(parent_e.classList.contains('tag--active') && tag_e == tag) {
        parent_e.classList.remove('tag--active');
        this.removeRedTag(tag);
        let index = this.tagsFilter.indexOf(tag);
        if (index !== -1) {
          this.tagsFilter.splice(index, 1);
        }
      }else if (!parent_e.classList.contains('tag--active') && tag_e == tag) {
        
        parent_e.classList.add('tag--active');

        let is_added = false;
        let tagListActiveItems = document.querySelectorAll('.tag--remove');
        
        if(tagListActiveItems.length > 0) {
          Array.from(tagListActiveItems).forEach(function(item){
            if(item.dataset.tag == tag) {
              is_added = true;
            }
          }, this);
        }
        if(!is_added) {
          this.addRedTag(tag);
        }
        
        if(!this.tagsFilter.includes(tag)) {
          this.tagsFilter.push(tag);
        }
      }
      this.btnOpenFilterText.innerText = 'Filter (' + this.tagsFilter.length + ')';
    }, this);

    if (this.tagsFilter.length > 0 && !this.btnOpenFilterMobile.classList.contains('btn--tertiary-active')) {
      this.btnOpenFilterMobile.classList.add('btn--tertiary-active');
    } else if (this.tagsFilter.length < 1){
      this.btnOpenFilterMobile.classList.remove('btn--tertiary-active');
      this.btnOpenFilterText.innerText = 'Filter';
    }
    
    this.data = [];
    
    this.render(true);
    if (theme.FilterDrawer) {
      theme.FilterDrawer.close();
    }
  }
  addRedTag(tag) {
    let tag_arr = tag.split('_');
    
    let html = '<span class="btn btn--small js-no-transition" title="Remove tag '+ tag +'">'+ tag_arr[1] +'</span>';
    html += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg>';

    let li_element = document.createElement('li');
    li_element.classList.add('tag','tag--remove');
    li_element.dataset.tag = tag;
    li_element.innerHTML = html;

    

    Array.from(this.tagListActive).forEach(function(ul){
      
      let duplicatedE = li_element.cloneNode(true);
      ul.appendChild(duplicatedE);

      this.actionRemoveRedTag(duplicatedE);
    }.bind(this));

  }

  removeRedTag(tag) {
  
    Array.from(this.tagListActive).forEach(function(ul){
      
      let tags_remove = ul.getElementsByTagName('li');
      for(let i = 0; i < tags_remove.length; i++) {
        if(tags_remove[i].dataset.tag == tag) {
          ul.removeChild(tags_remove[i]);
        }
      }
    }.bind(this));
    
  }

  actionRemoveRedTag(element) {
    let redTag = element.querySelector('span');
    redTag.addEventListener("click", function(e){
      
      let tag_remove = redTag.parentElement.dataset.tag;
        
      let index = this.tagsFilter.indexOf(tag_remove);
      if (index !== -1) {
        this.tagsFilter.splice(index, 1);
      }
      this.removeRedTag(tag_remove);

      
      Array.from(this.filterItems).forEach(function(item){
        let tag = item.dataset.tag;
        if(tag == tag_remove && item.parentElement.classList.contains('tag--active')) {
          item.parentElement.classList.remove('tag--active');
        }
      });
      if (this.tagsFilter.length < 1){
        this.btnOpenFilterMobile.classList.remove('btn--tertiary-active');
        this.btnOpenFilterText.innerText = 'Filter';
      } else {
        this.btnOpenFilterText.innerText = 'Filter (' + this.tagsFilter.length + ')';
      }
      this.data = [];
      this.render();
    }.bind(this));
  }
  showSortList(e) {
    e.preventDefault();
    let sortby_panel = document.getElementById("sortby-panel");
    let sortby_overlay = document.getElementById("sortby-overlay");
    if(sortby_panel.classList.contains("show_panel")) {
      sortby_panel.classList.remove("show_panel");
      sortby_overlay.classList.remove("active");
    }else{
      sortby_panel.classList.add("show_panel");
      sortby_overlay.classList.add("active");  
    }
  
  }
  sortHandler(e) {
    e.preventDefault();
    let li_element = e.currentTarget;
    let a_element = li_element.querySelector('a');
    
    let value = a_element.dataset.value;
    let item_name = '';
    Array.from(this.sortItems).forEach(function(item){
      let a_item = item.querySelector('a');
      if(a_item.dataset.value == value && !item.classList.contains("sortby-item--selected")) {
        item.classList.add("sortby-item--selected");
        item_name = item.getElementsByClassName('sortby-item-name')[0].innerText;
      }else{
        item.classList.remove("sortby-item--selected");
      }
    }, this);
    this.sortType = value;
    let current_sortby = this.sortSelect.getElementsByClassName('current-sortby')[0];
    current_sortby.innerText = 'Sort: ' + item_name;
    this.render();
    let sortby_panel = document.getElementById("sortby-panel");
    let sortby_overlay = document.getElementById("sortby-overlay");
    if(sortby_panel.classList.contains("show_panel")) {
      sortby_panel.classList.remove("show_panel");
      sortby_overlay.classList.remove("active");
    }
  }
  excludeProducts() {
    let searchResultsNumber = this.productsList.length;
    for(let i = 0; i < this.productsList.length; i++) {
      let isExclude = this.checkHasExclude(this.productsList[i].handle);
      if(isExclude) {
        let index = this.productsList.indexOf(this.productsList[i]);
        if (index !== -1) {
          this.productsList.splice(index, 1);
          searchResultsNumber -= 1;
        }
      }
    }
    let currentText = this.resultTextBreadcrumb.innerText;
    let newTextBreadcrumb = currentText.replace(this.resultNumber.toString(), searchResultsNumber);
    document.title = newTextBreadcrumb;
    this.resultTextBreadcrumb.innerText = newTextBreadcrumb;
  }
  formatData(type, data) {
    switch (type) {
      case 'title-ascending':
        data.sort((a, b) => a.title.localeCompare(b.title) || b.price - a.price);
        break;
      case 'title-descending':
        data.sort((a, b) => b.title.localeCompare(a.title) || b.price - a.price);
        break;
      case 'price-ascending':
        data.sort((a, b) => a.price - b.price);
        break;
      default:
        data.sort((a, b) => b.price - a.price);
        break;
    }
    
    return data;
  }
  scrollToTop() {
    let scrollHeight = this.productsContainer.offsetTop;
    window.scrollTo({ top: scrollHeight - 200, behavior: 'smooth'}); 
  }

}
customElements.define("search-wrapper", Search_Wrapper);

// Disable right click on frontend
if(false) {
  document.addEventListener("contextmenu", function (e){
    e.preventDefault();
  }, false);
}


class SwitchCollectionProductLayout extends HTMLElement {
  constructor() {
    super();
    this.switch_layout_collection_product();
  }

  switch_layout_collection_product() {
    let items = this.getElementsByClassName('item-layout');
    Array.from(items).forEach((element, i) => {
      element.addEventListener('click', function(e){
        e.preventDefault();
        Array.from(items).forEach((element, i) => {
          if(element.classList.contains('active')) {
            element.classList.remove('active');
          }
        });
        if(!this.classList.contains('active')) {
          this.classList.add('active');
        }
        let layout = this.dataset.layout;
        let products = document.querySelectorAll('.grid__item.grid-product');
        if(layout == 'grid') {
          Array.from(products).forEach((product, i) => {
            product.classList.remove('list-active');
          })
        }else if(layout == 'list') {
          Array.from(products).forEach((product, i) => {
            product.classList.add('list-active');
          })
        }
      });
    }) 
  }
}
customElements.define('switch-layout', SwitchCollectionProductLayout);

class ShippingDate extends HTMLElement{
  months = {
    0: 'January',
    1: 'February',
    2: 'March',
    3: 'April',
    4: 'May',
    5: 'June',
    6: 'July',
    7: 'August',
    8: 'September',
    9: 'October',
    10: 'November',
    11: 'December'
  }

  constructor(){
    super();
    this.num = this.getElementsByClassName("num")[0].value;

    let shippingDate = this.addWorkDays(new Date());

    this.innerText = shippingDate;
  }

  addWorkDays(startDate) {
    if(isNaN(this.num)) {
        console.log("Value provided for \"days\" was not a number");
        return
    }
    if(!(startDate instanceof Date)) {
        console.log("Value provided for \"startDate\" was not a Date object");
        return
    }
    // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
    var dow = startDate.getDay();
    var daysToAdd = parseInt(this.num);
    // If the current day is Sunday add one day
    if (dow == 0)
        daysToAdd++;
    // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
    if (dow + daysToAdd >= 6) {
        //Subtract days in current working week from work days
        var remainingWorkDays = daysToAdd - (5 - dow);
        //Add current working week's weekend
        daysToAdd += 2;
        if (remainingWorkDays > 5) {
            //Add two days for each working week by calculating how many weeks are included
            daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
            //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks
            if (remainingWorkDays % 5 == 0)
                daysToAdd -= 2;
        }
    }
    startDate.setDate(startDate.getDate() + daysToAdd);
    return startDate.getDate() + " " + this.months[startDate.getMonth()];
  }
}

customElements.define("shipping-date", ShippingDate);

// jQuery(window).on("resize", function () {
//     let width = window.innerWidth;
  
//     scope.sortContentOverviewTab();
//     //scope.readMoreOverviewTab();
//     scope.checkCurrentTabsVisible();
//     scope.sortContentMobileTab();
//     //scope.readMoreContentTab();
  
// });
(function () {
    var width = window.innerWidth;
    window.addEventListener('resize', function () {
       if (window.innerWidth !== width) {
           scope.sortContentOverviewTab();
           scope.checkCurrentTabsVisible();
           scope.sortContentMobileTab();
       }
    });
})();

jQuery(document).on('click','.grid-product_search_add-to-cart',function(e){
  e.preventDefault();
  if(!jQuery(this).hasClass('added')) {
    if(jQuery(this).hasClass('grid-product__add-to-cart')) {
      jQuery(this).addClass('added');
    }
    let variant_id = jQuery(this).data('variant');

    let formData = {
      'items': [{
      'id': variant_id,
      'quantity': 1
      }]
    };
    theme.cart.addItemFromForm(formData);
    window.addEventListener('cartUpdate', function(){
      let site_url = window.location.origin;
      window.location.replace(site_url + '/cart');
    });
  }
});